import { SVGProps } from 'react'

export const NoDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="220"
    height="160"
    viewBox="0 0 220 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="110" cy="80" r="80" fill="#EAECF0" />
    <circle cx="198" cy="126" r="6" fill="#F2F4F7" />
    <circle cx="25" cy="138" r="10" fill="#F2F4F7" />
    <circle cx="210" cy="46" r="10" fill="#F2F4F7" />
    <circle cx="191" cy="11" r="7" fill="#F2F4F7" />
    <g filter="url(#filter0_dd_5568_10193)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.6 24.4287C99.4608 24.4287 86.9534 31.4155 79.342 42.125C76.8565 41.5389 74.2645 41.2287 71.6 41.2287C53.0432 41.2287 38 56.2719 38 74.8287C38 93.3855 53.0432 108.429 71.6 108.429H155.6C171.837 108.429 185 95.2659 185 79.0287C185 62.7915 171.837 49.6287 155.6 49.6287C154.447 49.6287 153.309 49.6951 152.19 49.8243C145.754 34.8863 130.898 24.4287 113.6 24.4287Z"
        fill="#F9FAFB"
      />
      <circle cx="71.5" cy="74.5" r="33.5" fill="#F9FAFB" />
      <ellipse cx="113.5" cy="66" rx="41.5" ry="42" fill="#F9FAFB" />
      <circle cx="155.5" cy="78.5" r="29.5" fill="#F9FAFB" />
    </g>
    <g filter="url(#filter1_b_5568_10193)">
      <rect x="82" y="76" width="56" height="56" rx="28" fill="#667085" />
      <path
        d="M120.5 114.5L116.417 110.417M119.333 103.417C119.333 108.893 114.893 113.333 109.417 113.333C103.94 113.333 99.5 108.893 99.5 103.417C99.5 97.9398 103.94 93.5 109.417 93.5C114.893 93.5 119.333 97.9398 119.333 103.417Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_5568_10193"
        x="4"
        y="16"
        width="214"
        height="139.428"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_5568_10193"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5568_10193"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_5568_10193"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_5568_10193"
          result="effect2_dropShadow_5568_10193"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_5568_10193"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_5568_10193"
        x="74"
        y="68"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5568_10193"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5568_10193"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
